<div class="col-12 h-100" >
  <div class="px-2 mr-auto">
    <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" [(ngModel)]="reCaptcha" (success)="handleSuccess($event)"
      [useGlobalDomain]="false">
    </ngx-recaptcha2>
  </div>
</div>